module.exports = __webpack_public_path__ + "img/default-bg@2x.a45092a.png";